@if (displayHelptext()) {
    <div class="fieldsetLevel2 showHelp overlayHelp">
        <h2>
            <img hisImage="information" class="inlineicon" [title]="title()">
            {{'cs.sys.fieldset.help' | hisUi}} '{{subtitle()}}'
        </h2>
        <his-safe-html [html]="helptext()" />
    </div>
}